export const environment = {
  production: true,
  buildId: '2503876162717291',
  configFile: 'config.json',
};
